import { render, staticRenderFns } from "./chatSendMediaPreviewDialog.vue?vue&type=template&id=18e400f8&scoped=true"
import script from "./chatSendMediaPreviewDialog.vue?vue&type=script&lang=js"
export * from "./chatSendMediaPreviewDialog.vue?vue&type=script&lang=js"
import style0 from "./chatSendMediaPreviewDialog.vue?vue&type=style&index=0&id=18e400f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18e400f8",
  null
  
)

export default component.exports